import { getAPI, postAPI } from "../../api/api"
import { REACT_APP_CANDIDATEFILTER, REACT_APP_RECRUITER } from "../../utils/common"

export async function getCRresources(page: number, pageSize: number, tab: string, search: string, data: any) {
    const Details = postAPI( REACT_APP_CANDIDATEFILTER + `/filter-csr-candidate?page=1&size=25&tab=${tab}&search=${search}`, data)
    return Details
}